/**
 * VideoModal — the Media Centre video player modal.
 * Extracted from MediaCentre.js; behaviour identical to the original inline block.
 */
import React from 'react';
import LoadingSpinner from '../LoadingSpinner';
import { getVimeoEmbedUrl, getEmbeddableVideoUrl } from './helpers';

function VideoModal({ video, isLoading, videoSource, isEmbedded, onClose, onToggleFullscreen }) {
    const link = video.webURLLink || '';
    const isExternal =
        link.includes('vimeo.com') || link.includes('youtube.com') || link.includes('youtu.be');
    const title = video.topic || video.title;

    return (
        <div className="video-modal-overlay" onClick={onClose}>
            <div className="video-modal" onClick={(e) => e.stopPropagation()}>
                <div className="video-modal-header">
                    <h3>{title}</h3>
                    <div className="video-modal-controls">
                        <button className="fullscreen-btn" onClick={onToggleFullscreen} title="Toggle Fullscreen">
                            <i className="fas fa-expand"></i>
                            <i className="fas fa-compress"></i>
                        </button>
                        <button className="close-btn" onClick={onClose}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                <div className="video-modal-content">
                    {isExternal ? (
                        <iframe
                            src={link.includes('vimeo.com') ? getVimeoEmbedUrl(link) : getEmbeddableVideoUrl(link)}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            title={title}
                        ></iframe>
                    ) : (
                        /* Local blob / streamed video with loading state */
                        <>
                            {isLoading ? (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <LoadingSpinner />
                                </div>
                            ) : videoSource ? (
                                isEmbedded ? (
                                    <iframe
                                        src={videoSource}
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title={title}
                                    />
                                ) : (
                                    <video width="100%" height="100%" controls autoPlay src={videoSource}>
                                        Your browser does not support the video tag.
                                    </video>
                                )
                            ) : (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#666' }}>
                                    <p>Failed to load video</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
                <div className="video-modal-info">
                    <div className="video-modal-meta media-meta">
                        {video.duration && (
                            <span><i className="fas fa-clock"></i> {video.duration}</span>
                        )}
                        <span>
                            <i className="fas fa-calendar"></i>{' '}
                            {new Date(video.publishDate).toLocaleDateString('en-GB', {
                                day: 'numeric',
                                month: 'short',
                                year: 'numeric',
                            })}
                        </span>
                        <span className="entity"><i className="fas fa-building"></i> {video.entity}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoModal;
